import {getToken, setToken, removeToken} from '@/utils/auth'
import {resetRouter} from '@/router'
import http from '@/http/index'

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: '',
        phone: '',
        roles: null,
        permissions: null,
        userInfo: null,
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
    },

    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
    }
}

const actions = {
    // user login
    login({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            http.api('login', userInfo)
              .then(res => {
                if(res.status){
                  const {data} = res
                  commit('SET_TOKEN', data.access_token)
                  setToken(data.access_token)
                  resolve()
                }else{
                  reject(res.message)
                }

              })
              .catch(error => {
                reject('请求失败')
              })


        })
    },

    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            // http.api('current_user_data')
            //   .then(res => {
            //     const {data} = res
            //     commit('SET_ROLES', data.menu || [])
            //     commit('SET_NAME', data.name || '')
            //     commit('SET_PERMISSIONS', data.permissions)
            //     commit('SET_USERINFO',{id:data.id,name:data.name,phone:data.phone})
            //     resolve(data)
            //   })
            //   .catch(error => {
            //     reject(error)
            //   })
            commit('SET_ROLES', [1, 2, 3])
            commit('SET_NAME', '哈喽')
            commit('SET_PERMISSIONS', [1, 2, 3])
            commit('SET_USERINFO', {id: 1, name: "少爷", phone: '18404904737'})
            resolve({menu:[]})
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            removeToken()
            resetRouter()
            commit('SET_TOKEN', '')
            commit('SET_NAME', '')
            commit('SET_PERMISSIONS', [])
            commit('SET_ROLES', null)
            commit('SET_USERINFO', null)
            resolve();
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

